module.exports = __webpack_public_path__ + "static/grafika7@2x-e7fb1cdaafcc96de8385b6286fcf6f04.png";